<template>
  <div>
    <RevInputNumber
      id="telco_monthly_cost"
      v-model="monthlyCost"
      class="mt-16"
      :label="i18n(translations.monthlyCost)"
      :min="0"
      :precision="2"
      :step="5"
      @update:model-value="handleInputChange"
    />
    <div class="mt-16 flex justify-between">
      <div class="body-1">{{ i18n(translations.contractLength) }}</div>
      <div class="body-1-bold">
        {{
          i18n(translations.contractDurationByMonth, {
            duration: i18n(translations.contractDuration),
          })
        }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputNumber } from '@ds/components/InputNumber'

import translations from './USTelcoCalculatorModalCalculator.translations'

const props = defineProps<{
  price: Price
}>()

const emit = defineEmits<{
  (
    e: 'price-changed',
    payload: {
      priceTelco: number
      priceBM: number
      savings: number
    },
  ): void
}>()

const monthlyCost = ref<number>(50)

const i18n = useI18n()

function handleInputChange() {
  const devicePrice = parseInt(props.price.amount, 10)
  const contractDuration = parseInt(i18n(translations.contractDuration), 10)
  const monthlyCostBM = parseInt(i18n(translations.contractBMMonthlyCost), 10)

  const priceTelco = devicePrice + monthlyCost.value * contractDuration
  const priceBM = devicePrice + monthlyCostBM * contractDuration
  const savings = priceTelco - priceBM

  emit('price-changed', { priceTelco, priceBM, savings })
}

onMounted(() => {
  handleInputChange()
})
</script>
